import React, { useEffect, useState } from "react";
import { mainTable } from "../css/Common";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserCapability } from "./ConstantReducerProvider";
import DropDown from "../ReusableComponents/DropDown";
import { BindAPI } from "../services/APIConnection";
import ReportTableGrid from "./TablewithCheckBox";
import TableWithCheckBox from "./TablewithCheckBox";
import { useAppData } from "./AppDataContext";

const GridPageWithCheckBox = ({
  title,
  showAdd,
  addView,
  receiveView,
  addClientView,
  showReceive,
  tableHeight,
  handleExport,
  handleDownload,
  header,
  handleEdit,
  records,
  handleAction,
  handleSchoolView,
  isGenderBased,
  xScroll,
  onSelectedGrid,
  selectedRowTableData,
  checkBoxStatus,
  selectedRows,
  checkBoxVisible,
  checkBoxHeaderVisible,
  checkSubmissionVisible,
  checkAttachmentVisible,
  isMultiSelect,
  onLaundryIssueView,
  rowsPerPageView,
  onSpaceDatas,
  onSpaceDataClear,
  onSpaceDataClearFalse,
  onAmenitiesDatas,
}) => {
  //search state start
  const [searchInput, setSearchInput] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const { userProfileState } = useUserCapability();
  const userVsCapability = userProfileState.userVsCapability;
  const navigate = useNavigate();
  const [viewBag, setViewBag] = useState(0);
  const [rowsPerPageVisible, setRowsPerPageVisible] = useState(1);

  const location1 = useLocation();
  const userSideMenu = location1?.state?.menuId;
  const [editBag, setEditBag] = useState(0);
  const [deleteBag, setDeleteBag] = useState(0);
  const [blockBag, setBlockBag] = useState(0);
  const [serviceBag, setServiceBag] = useState(0);

  const [addBag, setAddBag] = useState(0);
  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
    if (Array.isArray(userVsCapability) && userVsCapability.length > 0) {
      let menuFilter = userVsCapability.filter(
        (menu) => menu.MstMenuId == userSideMenu
      );
      setViewBag(menuFilter[0]?.ViewPermission);
      if (addView) {
        setAddBag(0);
      } else {
        setAddBag(menuFilter[0]?.AddPermission);
      }
      setEditBag(menuFilter[0]?.ModifyPermission);
      setDeleteBag(menuFilter[0]?.DeletePermission);
      setBlockBag(menuFilter[0]?.BlockPermission);
      setServiceBag(menuFilter[0]?.ProvideServicePermission);
    }
  }, [userVsCapability, addView]);

  useEffect(() => {
    if (addClientView) {
      setAddBag(1);
    }
  }, []);
  useEffect(() => {
    if (rowsPerPageView) {
      setRowsPerPageVisible(0);
    }
  }, []);
  //search state end
  // useEffect(() => {
  //   if (records) {
  //     setSearchData(records);
  //   }
  // }, [records]);

  useEffect(() => {
    if (records && !isInitialized) {
      const recordsWithIndex = records.map((record, index) => ({
        ...record,
        rowIndex: index, // current index
        oldIndex: index, // set oldIndex only the first time
      }));
      setTableData(recordsWithIndex);
      setSearchData(recordsWithIndex);
    }
  }, [records ? records : null]);

  //next page state start
  const [currentPage, setCurrentPage] = useState(1);
  //next page state end
const { itemsPerPages, bindDDValues, loading } = useAppData();
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPages);

  // const handleDropDown = (event) => {
  //   const selectedValue = parseInt(event.target.value);
  //   setItemsPerPage(selectedValue);
  //   setCurrentPage(1);
  // };
  const handleDropDown = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "ALL") {
      setItemsPerPage(-1); // Setting a large number or use Infinity to bypass pagination
    } else {
      setItemsPerPage(parseInt(selectedValue));
    }
    setCurrentPage(1); // Reset to the first page
  };

  useEffect(() => {
    var createdBy = sessionStorage.getItem("createdBy");
    if (createdBy == null || createdBy == "") {
      navigate("/");
    }
    if (Array.isArray(userVsCapability) && userVsCapability.length > 0) {
      let menuFilter = userVsCapability.filter(
        (menu) => menu.MstMenuId == userSideMenu
      );
      setViewBag(menuFilter[0]?.ViewPermission);
    }
  }, [navigate]);

  const handleSearchInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
    handleSearch(inputValue);
    setCurrentPage(1);
  };
  const handleSearch = (input) => {
    if (input === "") {
      // Reset search data to the original records
      const recordsWithIndex = tableData.map((record, index) => ({
        ...record,
        rowIndex: index,
      }));
      setSearchData(recordsWithIndex);
    } else {
      setIsInitialized(true);
      const normalizedInput = input.toLowerCase();
      const filtered = tableData.filter((item) => {
        const matchFound = header.some((data) => {
          const userDataKey = data.key;
          const userDataValue = item[userDataKey];

          if (userDataValue && typeof userDataValue === "string") {
            const normalizedValue = userDataValue.toLowerCase();

            // Check if input matches the start of any word
            return normalizedValue.split(" ").some(
              (word) => word.startsWith(normalizedInput) // Checks if the input matches the start of the word
            );
          }
          return false;
        });

        return matchFound;
      });

      const filteredWithIndex = filtered.map((record) => ({
        ...record,
        rowIndex: tableData.findIndex((r) => r === record),
      }));

      setSearchData(filteredWithIndex);
    }
  };

  return (
    <div className={loading ? "lex justify-center items-center h-full" : ""}>
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <div className="loader"></div>
        </div>
      ) : (
        <div>
          <div className={mainTable.headerTitle}>
            <div className={mainTable.gridTableHeader}>{title}</div>
          </div>
          <div className="relative mt-1 md:hidden">
            <div className={mainTable.searchIconPosition}>
              <svg
                className={mainTable.searchIconSvg}
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              className={mainTable.searchInputBox}
              placeholder="Search for items"
              value={searchInput}
              onChange={handleSearchInputChange}
            />
          </div>
          <div className="justify-between flex items-center">
            {rowsPerPageVisible == 1 && (
              <div className={mainTable.searchAdd}>
                <DropDown
                  classDiv="md:mt-1 mt-0 gap-2 flex flex-col md:flex-row items-start md:items-center justify-between"
                  Class={mainTable.dropDownRecords}
                  title="Rows Per Page:"
                  options={bindDDValues}
                  placeholder="Select"
                  name="ddValues"
                  selectedOption={itemsPerPage === -1 ? "ALL" : itemsPerPage}
                  controlFunc={handleDropDown}
                />
                <div>
                  <label for="table-search" className="sr-only">
                    Search
                  </label>
                </div>
                <div className="hidden md:block relative mt-1">
                  <div className={mainTable.searchIconPosition}>
                    <svg
                      className={mainTable.searchIconSvg}
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </div>
                  <input
                    type="text"
                    className={mainTable.searchInputBox}
                    placeholder="Search for items"
                    value={searchInput}
                    onChange={handleSearchInputChange}
                  />
                </div>
              </div>
            )}
            <div className="flex flex-col sm:flex sm:flex-row gap-1.5 self-end m-1.5">
              {checkSubmissionVisible && (
                <button
                  type="button"
                  className={mainTable.addButton}
                  onClick={handleExport} // Assuming you have a function named handleExport for exporting
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="25"
                    height="20"
                  >
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                  </svg>
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="25"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M21.17 3.25q.33 0 .59.25.24.24.24.58v15.84q0 .34-.24.58-.26.25-.59.25H7.83q-.33 0-.59-.25-.24-.24-.24-.58V17H2.83q-.33 0-.59-.24Q2 16.5 2 16.17V7.83q0-.33.24-.59Q2.5 7 2.83 7H7V4.08q0-.34.24-.58.26-.25.59-.25M7 13.06l1.18 2.22h1.79L8 12.06l1.93-3.17H8.22L7.13 10.9l-.04.06-.03.07q-.26-.53-.56-1.07-.25-.53-.53-1.07H4.16l1.89 3.19L4 15.28h1.78m8.1 4.22V17H8.25v2.5m5.63-3.75v-3.12H12v3.12m1.88-4.37V8.25H12v3.13M13.88 7V4.5H8.25V7m12.5 12.5V17h-5.62v2.5m5.62-3.75v-3.12h-5.62v3.12m5.62-4.37V8.25h-5.62v3.13M20.75 7V4.5h-5.62V7z" />
                  </svg>
                  Submissions
                </button>
              )}
              {addBag == 1 && (
                <div className="flex gap-1">
                  {receiveView == true && (
                    <button
                      type="button"
                      className={mainTable.addButton}
                      onClick={showReceive}
                    >
                      <svg
                        width="25"
                        height="18"
                        viewBox="0 0 50 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.5 37.5H27.5V27.5H37.5V22.5H27.5V12.5H22.5V22.5H12.5V27.5H22.5V37.5ZM25 50C21.5417 50 18.2917 49.3433 15.25 48.03C12.2083 46.7183 9.5625 44.9375 7.3125 42.6875C5.0625 40.4375 3.28167 37.7917 1.97 34.75C0.656667 31.7083 0 28.4583 0 25C0 21.5417 0.656667 18.2917 1.97 15.25C3.28167 12.2083 5.0625 9.5625 7.3125 7.3125C9.5625 5.0625 12.2083 3.28083 15.25 1.9675C18.2917 0.655833 21.5417 0 25 0C28.4583 0 31.7083 0.655833 34.75 1.9675C37.7917 3.28083 40.4375 5.0625 42.6875 7.3125C44.9375 9.5625 46.7183 12.2083 48.03 15.25C49.3433 18.2917 50 21.5417 50 25C50 28.4583 49.3433 31.7083 48.03 34.75C46.7183 37.7917 44.9375 40.4375 42.6875 42.6875C40.4375 44.9375 37.7917 46.7183 34.75 48.03C31.7083 49.3433 28.4583 50 25 50ZM25 45C30.5833 45 35.3125 43.0625 39.1875 39.1875C43.0625 35.3125 45 30.5833 45 25C45 19.4167 43.0625 14.6875 39.1875 10.8125C35.3125 6.9375 30.5833 5 25 5C19.4167 5 14.6875 6.9375 10.8125 10.8125C6.9375 14.6875 5 19.4167 5 25C5 30.5833 6.9375 35.3125 10.8125 39.1875C14.6875 43.0625 19.4167 45 25 45Z"
                          fill="currentColor"
                        />
                      </svg>
                      {receiveView === true ? "Receive" : ""}
                    </button>
                  )}
                  <button
                    type="button"
                    className={mainTable.addButton}
                    onClick={showAdd}
                  >
                    <svg
                      width="25"
                      height="18"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.5 37.5H27.5V27.5H37.5V22.5H27.5V12.5H22.5V22.5H12.5V27.5H22.5V37.5ZM25 50C21.5417 50 18.2917 49.3433 15.25 48.03C12.2083 46.7183 9.5625 44.9375 7.3125 42.6875C5.0625 40.4375 3.28167 37.7917 1.97 34.75C0.656667 31.7083 0 28.4583 0 25C0 21.5417 0.656667 18.2917 1.97 15.25C3.28167 12.2083 5.0625 9.5625 7.3125 7.3125C9.5625 5.0625 12.2083 3.28083 15.25 1.9675C18.2917 0.655833 21.5417 0 25 0C28.4583 0 31.7083 0.655833 34.75 1.9675C37.7917 3.28083 40.4375 5.0625 42.6875 7.3125C44.9375 9.5625 46.7183 12.2083 48.03 15.25C49.3433 18.2917 50 21.5417 50 25C50 28.4583 49.3433 31.7083 48.03 34.75C46.7183 37.7917 44.9375 40.4375 42.6875 42.6875C40.4375 44.9375 37.7917 46.7183 34.75 48.03C31.7083 49.3433 28.4583 50 25 50ZM25 45C30.5833 45 35.3125 43.0625 39.1875 39.1875C43.0625 35.3125 45 30.5833 45 25C45 19.4167 43.0625 14.6875 39.1875 10.8125C35.3125 6.9375 30.5833 5 25 5C19.4167 5 14.6875 6.9375 10.8125 10.8125C6.9375 14.6875 5 19.4167 5 25C5 30.5833 6.9375 35.3125 10.8125 39.1875C14.6875 43.0625 19.4167 45 25 45Z"
                        fill="currentColor"
                      />
                    </svg>
                    {addClientView === true ? "Send" : "Add"}
                  </button>
                </div>
              )}
              {checkAttachmentVisible && (
                <button
                  type="button"
                  className={mainTable.addButton}
                  onClick={handleDownload} // Assuming you have a function named handleExport for exporting
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="25"
                    height="20"
                  >
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />{" "}
                  </svg>
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    width="25"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 2a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm7 1.5L18.5 9H13V3.5zM8 14h1.5v1H10v1H9.5v1H8v-3zm3 0h1.5v3H11v-3zm2.5 0H15a.5.5 0 0 1 0 1h-1v2H13v-3z" />
                  </svg>
                  Attachments
                </button>
              )}
            </div>
          </div>
          <TableWithCheckBox
            className={mainTable.table}
            tableHeight={tableHeight}
            isGenderBased={isGenderBased}
            headerData={header}
            tableData={searchData.length > 0 ? searchData : records}
            onViewGrid={handleAction ? handleAction : ""}
            onEditGrid={handleEdit ? handleEdit : ""}
            onBlockGrid={handleAction ? handleAction : ""}
            onDeleteGrid={handleAction ? handleAction : ""}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            viewBag={viewBag}
            serviceBag={serviceBag}
            editBag={editBag}
            deleteBag={deleteBag}
            blockBag={blockBag}
            onSchoolView={handleSchoolView ? handleSchoolView : ""}
            xScroll={xScroll}
            onSelectedGrid={onSelectedGrid}
            selectedRowTableData={selectedRowTableData}
            checkBoxStatus={checkBoxStatus}
            selectedRows={selectedRows}
            checkBoxVisible={checkBoxVisible}
            checkBoxHeaderVisible={checkBoxHeaderVisible}
            isMultiSelect={isMultiSelect}
            onLaundryIssueView={onLaundryIssueView}
            onSpaceDatas={onSpaceDatas}
            onAmenitiesDatas={onAmenitiesDatas}
            onSpaceDataClear={onSpaceDataClear}
            onSpaceDataClearFalse={onSpaceDataClearFalse}
          />
          {rowsPerPageVisible == 1 && (
            <div className={mainTable.submitCancelMainDiv}>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={mainTable.submitButton}
              >
                Previous Page
              </button>
              <label>
                {itemsPerPage === -1
                  ? `${currentPage} out of ${1}`
                  : `${currentPage} out of ${Math.ceil(
                    searchData?.length / itemsPerPage
                  )} pages`}
              </label>
              <button
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                }}
                disabled={currentPage >= records.length / itemsPerPage}
                className={mainTable.cancelButton}
              >
                Next Page
              </button>
            </div>)}
        </div>
      )}
    </div>
  );
};

export default GridPageWithCheckBox;
